import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { kn_IN } from 'ng-zorro-antd/i18n/public-api';

@Injectable({
    providedIn: 'root'
})
export class KnowledgeService {



    constructor(public httpClient: HttpClient) { }


    /**
     * 查询知识库类型
     */
    async  queryKnowledgeType() {
        const url = 'plan/api/knowledge/knowledgeType';
        const ret: any = await this.httpClient.get(url).toPromise();
        return ret;
    }
    /**
     * 查询知识库数据
     * @param param 条件
     * @param pageNum 页码
     * @param pageSize 行数/页
     */
    async queryKnowledgeData(param: any, pageNum: number, pageSize: number) {
        let url = 'plan/api/knowledge/knowledge' + '?pageNum=' + pageNum +
            '&pageSize=' + pageSize;
        if (param.knowledgeName == null || param.knowledgeName === undefined || param.knowledgeName === '') {
        } else {
            url = url + '&search=' + param.knowledgeName;
        }
        if (param.typeId == null || param.typeId === undefined || param.typeId === 999) {
        } else {
            url = url + '&typeId=' + param.typeId;
        }
        const ret: any = await this.httpClient.get(url).toPromise();
        return ret;
    }
    /**
     * 保存知识点
     */
    async saveKnowledge(param: any, filePath: any[]) {
        const url = 'plan/api/knowledge/knowledge';
        let knowledge = null;
        knowledge = {
            kname: param.kname,
            ktNo: param.ktNo,
            responser: param.responser,
            desc: param.desc,
            filePaths: filePath
        };
        const ret: any = await this.httpClient.post(url, knowledge).toPromise();
        return ret;
    }

    async deleteKnowledge(kno: number) {
        const url = 'plan/api/knowledge/knowledge';
        const ret: any = await this.httpClient.delete(url, { params: { 'kNo': [kno + ''] } }).toPromise();
        return ret;
    }

    async queryKnowledgeAttachment(kno: string) {
        const url = 'plan/api/business/attachment/KnowledgeAttachment?kno=' + kno;
        const ret: any = await this.httpClient.get(url).toPromise();
        return ret;
    }


    /**
     * 修改知识点
     */
    async editKnowledge(kNo: string, param: any, filePath: any[]) {
        const url = 'plan/api/knowledge/knowledge';
        let knowledge = null;
        knowledge = {
            kno: kNo,
            kname: param.kname,
            ktNo: param.ktNo,
            responser: param.responser,
            desc: param.desc,
            filePaths: filePath
        };
        const ret: any = await this.httpClient.put(url, knowledge).toPromise();
        return ret;
    }
    /**
     * 查询知识点详情
     * @param kno 知识编号
     */
    async queryKnowledgeDataById(kno: string) {
        const url = 'plan/api/knowledge/KnowledgeDetail?kNo=' + kno;
        const ret: any = await this.httpClient.get(url).toPromise();
        return ret;
    }
}
